export const CHAT_AUTHOR_COLORS = [
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#00897b',
  '#43a047',
  '#fb8c00',
  '#6d4c41',
  '#546e7a',
];

const CHAT_AUTHOR_COLOR_SET = new Set(
  CHAT_AUTHOR_COLORS.map((color) => color.toLowerCase()),
);

const DEFAULT_PHOTO_MARKERS = [
  'path_to_default_profile_image.png',
  'default_profile',
  'placeholder',
];

/** Stable fallback when the user has not chosen a chat color yet. */
export function authorColorFromUid(uid) {
  const value = String(uid || '').trim();
  if (!value) {
    return CHAT_AUTHOR_COLORS[CHAT_AUTHOR_COLORS.length - 1];
  }

  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return CHAT_AUTHOR_COLORS[Math.abs(hash) % CHAT_AUTHOR_COLORS.length];
}

export function isValidChatColor(color) {
  return CHAT_AUTHOR_COLOR_SET.has(String(color || '').trim().toLowerCase());
}

export function normalizeChatColor(color) {
  const value = String(color || '').trim().toLowerCase();
  return isValidChatColor(value) ? value : '';
}

/** Prefer profile chatColor; fall back to uid hash for legacy users. */
export function resolveAuthorColor(uid, chatColor) {
  const normalized = normalizeChatColor(chatColor);
  if (normalized) {
    return normalized;
  }
  return authorColorFromUid(uid);
}

export function isUsableProfilePhotoUrl(url) {
  const value = String(url || '').trim();
  if (!value) {
    return false;
  }

  const lower = value.toLowerCase();
  if (DEFAULT_PHOTO_MARKERS.some((marker) => lower.includes(marker))) {
    return false;
  }

  return /^https?:\/\//i.test(value);
}

export function authorInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
